<template lang="pug">
    include ../../media/pug/mixins
    +b.cart-item(
        v-bind:class="{'cart-item_theme_full': themeFull}"
    )
        +e.BUTTON.remove.btn(
            type="button"
        )
            +e.V-ICON.remove-icon(name="close")
        +e.header
            +e.H4.title.title_size_sm Пришвин, Михаил Михайлович
            +e.H4.title.title._size_sm.text-silver Без указания Автора
            +e.P.desc Лисичкин хлеб [Текст] : рассказы, cказка-быль : [для среднего школьного возраста : 0+]
        collapse-transition
            +e.content(v-if="contentIsOpened || themeFull")
                +e.pages
                    +e.pages-block
                        +e.pages-header
                            +e.V-ICON.pages-icon(name="bw")
                            +e.pages-title.title._size_xs Страницы Ч / Б
                        +e.UL.pages-list
                            +e.LI.pages-item(
                                v-for="item in 3"
                                v-bind:key='item'
                                v-bind:class="{'cart-item__pages-item_bw' : !themeFull}"
                                v-tooltip="tooltip"
                            )
                                +e.SPAN.pages-count 1002
                                +e.BUTTON.pages-remove.btn(
                                    type="button"
                                )
                                    +e.V-ICON.pages-close(name="close")
                    +e.pages-block
                        +e.pages-header
                            +e.V-ICON.pages-icon(name="color")
                            +e.pages-title.title._size_xs Страницы цветные
                        +e.UL.pages-list
                            +e.LI.pages-item(
                                v-for="item in 3"
                                v-bind:key='item'
                                v-bind:class="{'cart-item__pages-item_color' : !themeFull}"
                                v-tooltip="tooltip"
                            )
                                +e.SPAN.pages-count 1002
                                +e.BUTTON.pages-remove.btn(
                                    type="button"
                                )
                                    +e.V-ICON.pages-close(name="close")
                +e.info(v-if="!themeFull")
                    +e.H3.info-title.title._size_xxs Использованные лимиты для заказа на печать
                    +e.UL.info-list
                        +e.LI.info-item #[b за день: 0] из #[b 130] страниц #[span (100% от документа)]
                        +e.LI.info-item #[b за неделю: 0] из #[b 130] страниц #[span (100% от документа)]
                        +e.LI.info-item #[b за месяц: 0] из #[b 130] страниц #[span (100% от документа)]
        +e.footer
            +e.BUTTON.toggle-btn.btn._round(
                type="button"
                v-if="!themeFull"
                v-on:click="toggleContent"
                v-bind:class="{'is-active' : contentIsOpened}"
            )
            +b.UL.cart-item-list
                +e.LI.item
                    +e.col
                        +e.SPAN.key Всего страниц
                    +e.col
                        +e.SPAN.value 36 стр.
                +e.LI.item
                    +e.col
                        +e.SPAN.key Сумма заказа
                    +e.col
                        +e.SPAN.value 252 р.
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';
import url from '@/helpers/api';

export default {
    components: {
        CollapseTransition
    },
    props: {
        themeFull: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            contentIsOpened: false
        };
    },
    computed: {
        tooltip() {
            return {
                content: `
                <img
                    src="${url()}/viewer/pdf?docId=${this.$route.params.id}&page=${this.$route.query.page}&type=preview"
                    alt="123"
                >
                </img`,
                classes: 'cart-item__tooltip',
                placement: 'bottom',
                offset: 10
            };
        }
    },
    methods: {
        toggleContent() {
            this.contentIsOpened = !this.contentIsOpened;
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/global/cart-item.sass"></style>
